const prefix = '@saiplay';

export const FETCH_SAILPLAY_BONUSES_REQUEST = `${prefix}/FETCH_SAILPLAY_BONUSES_REQUEST`;
export const FETCH_SAILPLAY_BONUSES_SUCCESS = `${prefix}/FETCH_SAILPLAY_BONUSES_SUCCESS`;
export const FETCH_SAILPLAY_BONUSES_FAILURE = `${prefix}/FETCH_SAILPLAY_BONUSES_FAILURE`;

export const RESET_SAILPLAY_STATE = `${prefix}/RESET_SAILPLAY_STATE`;